module.exports = __webpack_public_path__ + "img/hf_logo.bb3bf232.png";